import styled from 'styled-components';

// Import styles
import { baseRootStyle, media, flex } from 'components/styles';

export const Root = styled.div`
	${flex()};
	width: 100%;
	height: 100%;
	min-height: 3em;
	padding: 1.75em 2em;
	overflow: hidden;
	column-gap: 0.5em;
	color: ${({ theme }) => theme.white};
	text-decoration: none;
	position: relative;
	cursor: pointer;
	font-size: 1em;

	${media.min.min(baseRootStyle)};

	&:disabled {
		cursor: not-allowed;
	}
`;
